export default __webpack_public_path__ + "static/footer-blob-mobile-fb536631d398b46c4b0e1eb79a01ee46.png";